import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as languagesApi from '@/features/languages/languages.api';

interface LanguagePickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const LanguagePicker = ({
  label = 'Language',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: LanguagePickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.languages',
      fetch: async (search) => {
        const res = await languagesApi.listLanguages({
          page: 1,
          pageSize: 30,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await languagesApi.getLanguage(id);
        } catch {
          return null;
        }
      },
      toOption: (l) => ({
        value: l.id,
        label: l.name,
        description: l.nativeName ?? l.code ?? undefined,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select a language"
      searchPlaceholder="Search languages..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
